import { useEffect, useRef, useState } from 'react'

import PrimaryButton from '../../../components/PrimaryButton/PrimaryButton'
import { usePromo } from '../../../context/promoContext'
import useStrings from '../../../localization/useStrings'
import styles from './LimitedTimePaywallBottom.module.scss'

interface Props {
  containerClassName: string
}

const LimitedTimePaywallBottom = (props: Props) => {
  const [secondsRemaining, setSecondsRemaining] = useState(120)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setSecondsRemaining((prevSeconds) => {
        if (prevSeconds <= 0) {
          if (intervalRef.current != null) {
            clearInterval(intervalRef.current)
          }
          return 0
        }
        return prevSeconds - 1
      })
    }, 1000)
  }, [])

  const strings = useStrings().promo
  const promo = usePromo()
  const pricing = promo.state.pricing

  const savingPercent = pricing.savingPercent.toString()
  const monthlyPrice = pricing.monthlyPrice.formatted
  const yearlyPriceDiscounted = pricing.yearlyPriceDiscounted.formatted
  const yearlyPriceFull = pricing.yearlyPriceFull.formatted

  return (
    <div className={`${styles.container} ${props.containerClassName}`}>
      <label className={styles.save}>{strings.premiumSave(savingPercent)}</label>
      <label className={styles.title}>{strings.monthly(monthlyPrice)}</label>
      <label className={styles.subtitle}>
        {strings.yearly(yearlyPriceDiscounted)} (
        <label className={styles.crossed}>{yearlyPriceFull}</label>)
      </label>
      <div className={styles.spacer} />
      <label>{strings.limited}</label>
      <CountDown secondsRemaining={secondsRemaining} />
      <PrimaryButton
        className={styles.cta}
        onClick={() => {
          promo.actions.subscribe()
        }}
      >
        {strings.claimOffer}
      </PrimaryButton>
      <div className={styles.safeAreaExtension} />
    </div>
  )
}

interface CoundDownProps {
  secondsRemaining: number
}

const CountDown = (props: CoundDownProps) => {
  const strings = useStrings().promo

  const totalSeconds = props.secondsRemaining
  const seconds = totalSeconds % 60
  const minutes = Math.floor(totalSeconds / 60)

  const secondsString = String(seconds).padStart(2, "0")
  const minutesString = String(minutes).padStart(2, "0")

  const secondsTitle = strings.seconds(seconds)
  const minutesTitle = strings.minutes(minutes)

  return (
    <div className={styles.countDownContainer}>
      <CoundDownItem title={minutesTitle} value={minutesString} />
      <CoundDownItem title={secondsTitle} value={secondsString} />
    </div>
  )
}

interface CoundDownItemProps {
  title: string
  value: string
}

const CoundDownItem = (props: CoundDownItemProps) => {
  return (
    <div className={styles.countDownItem}>
      <label className={styles.countDownValue}>{props.value}</label>
      <label className={styles.countDownTitle}>{props.title}</label>
    </div>
  )
}

export default LimitedTimePaywallBottom
